<template>
  <div style="width: 100%;height: 100%">
    <div style="margin-left: 20px;position: relative;height: 100%">
      <div style="height: 40px">
        <div style="color: #1a1a1a;font-size: 24px;"><strong>基本信息</strong></div>
      </div>
      <div style="height: calc(100% - 80px);margin-top: 20px;">
        <el-form :model="addEditForm" :rules="addEditRules" ref="addEditForm" label-width="95px" class="demo-ruleForm">
          <el-row>
            <el-col :span="16">
              <el-form-item label="书籍名称" prop="name">
                <el-input v-model="addEditForm.name" placeholder="请输入书籍名称"></el-input>
              </el-form-item>
<!--              <el-form-item label="出版社" prop="">-->
<!--                <el-input placeholder="请输入出版社"></el-input>-->
<!--              </el-form-item>-->
              <el-form-item label="作者" prop="author">
                <el-input v-model="addEditForm.author" placeholder="请输入作者"></el-input>
              </el-form-item>
              <el-form-item label="内容提要" prop="author">
                <el-input type="textarea" rows="4" v-model="addEditForm.desc" placeholder="请输入内容提要"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <div style="width: 90px;margin: auto">
                <el-upload
                  class="avatar-uploader"
                  action="#"
                  :auto-upload="false"
                  :show-file-list="false"
                  list-type="picture">
                  <i class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </div>
              <div style="font-size: 16px;text-align: center;color: #409EFF">
                <span>上传封面</span>
              </div>
              <div style="font-size: 14px;text-align: center;color: #999999"><span>jpeg/jpg/png格式，且不超过300KB</span></div>
            </el-col>
          </el-row>
<!--          <el-form-item label="内容提要" prop="author">-->
<!--            <el-input type="textarea" rows="4" v-model="addEditForm.desc" placeholder="请输入内容提要"></el-input>-->
<!--          </el-form-item>-->
        </el-form>
      </div>
      <div v-if="isShowButton" style="width: 100%;height: 40px;position: absolute;bottom: 0">
        <el-button type="primary" class="sure-btn" style="float: right" @click="submitBook('addEditForm')">确认</el-button>
        <el-button v-if="isShowDelete" type="danger" class="del-btn" style="float: right;margin-right: 40px" @click="delBook()">删除</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import {addBook, delBook, editBook} from '../../api/book'

export default {
  name: 'addEditBook',
  model: {
    prop: 'addEditShow',
    event: 'change'
  },
  data () {
    return {
      addEditObj: '',
      addEditForm: {
        name: '',
        desc: '',
        author: '',
        note: '',
        coverUrl: ''
      },
      addEditRules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ]
      },
      isShowButton: false,
      isShowDelete: false
    }
  },
  methods: {
    getInitData (obj) {
      this.addEditObj = obj
      this.isShowButton = this.addEditObj.type !== 2
      this.isShowDelete = this.addEditObj.type !== 0
      if (this.addEditObj.type !== 0) {
        this.addEditForm = {
          name: this.addEditObj.row.name,
          desc: this.addEditObj.row.desc,
          author: this.addEditObj.row.author,
          note: this.addEditObj.row.note,
          coverUrl: this.addEditObj.row.coverUrl
        }
      } else {
        this.addEditForm = {
          name: '',
          desc: '',
          author: '',
          note: '',
          coverUrl: ''
        }
      }
    },
    submitBook (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.addEditObj.type === 0) {
            this.sendAddBook()
          } else if (this.addEditObj.type === 1) {
            this.sendEditBook()
          }
        } else {
          return false
        }
      })
    },
    sendAddBook () {
      let body = {
        name: this.addEditForm.name,
        note: this.addEditForm.note,
        desc: this.addEditForm.desc,
        author: this.addEditForm.author,
        coverUrl: this.addEditForm.coverUrl
      }
      addBook(body).then(res => {
        this.$message({
          message: '成功添加书本',
          type: 'success'
        })
        this.$emit('getFatherBook')
        this.$emit('change', false)
      })
    },
    sendEditBook () {
      let body = {
        id: this.addEditObj.row.id,
        companyId: this.addEditObj.row.companyId,
        name: this.addEditForm.name,
        note: this.addEditForm.note,
        desc: this.addEditForm.desc,
        author: this.addEditForm.author,
        coverUrl: this.addEditForm.coverUrl
      }
      editBook(body).then(res => {
        this.$message({
          message: '成功更新书本',
          type: 'success'
        })
        this.$emit('getFatherBook')
        this.$emit('change', false)
      })
    },
    delBook () {
      let name = this.addEditObj.row.name
      this.$confirm('此操作将永久删除该书本【' + name + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        let id = this.addEditObj.row.id
        delBook(id).then(res => {
          this.$message({
            message: '成功删除书本',
            type: 'success'
          })
          this.$emit('getFatherBook')
          this.$emit('change', false)
        })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/materialManagement/addEditBook.vue